module.exports = __webpack_public_path__ + "img/black-cut.91e624d4.png";